import * as React from 'react';

import type {UnserializedFilterObject} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import {CloseButton} from 'shells/button/close-button/close-button';
import {Dialog} from 'shells/dialog/dialog';
import {Popover} from 'shells/popover/popover';
import type {LocationEnum} from 'shells/popover/popover';

// @ts-expect-error
import getClassesMixin from '../mixins/get-classes';

// @ts-expect-error
import {FilterFormDeprecated} from './filter-form-deprecated';

type Props = {
    anchor: HTMLElement | null | undefined;
    onSubmit: (arg1: UnserializedFilterObject<any>) => void;
    onRemove: (e: React.SyntheticEvent) => void;
    onClose: () => void;
    field: any;
    value?: any | string;
    filter: any | string | null | undefined;
    location?: LocationEnum;
};

type State = {
    isDirty: boolean;
    confirmClose: boolean;
};

export class PopoverForm extends React.Component<Props, State> {
    getClasses = getClassesMixin;
    closeButton: HTMLElement | null | undefined;

    static defaultProps = {
        location: 'bottom',
        // @ts-expect-error
        onRemove: (e) => e,
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            isDirty: false,
            confirmClose: false,
        };
    }

    render() {
        const classes = this.getClasses('ui-popover ui-popover-form');

        return (
            <Popover
                className={classes}
                anchor={this.props.anchor}
                location={this.props.location}
                onBlur={this.handleClose}
            >
                <div className='toolbar'>
                    <h1 className='ui-header ui-header--md'>{this.props.field.title}</h1>
                </div>
                <div className='inner-wrapper'>
                    <CloseButton
                        getRef={(c) => {
                            this.closeButton = c;
                        }}
                        className='ui-btn__popover-close'
                        onClick={this.handleClose}
                    />
                    <div className='ui-popover-form__form-container'>
                        <FilterFormDeprecated
                            className='ui-form--popover-form'
                            field={this.props.field}
                            value={this.props.value}
                            // @ts-expect-error
                            onDirty={(isDirty) => this.setState({isDirty: isDirty})}
                            onSubmit={this.handleSubmit}
                        />
                    </div>
                    {this.props.filter && !this.props.field.unclearable ? (
                        <Button variant='danger' size='big' onClick={this.props.onRemove}>
                            Remove filter
                        </Button>
                    ) : undefined}
                </div>
                {this.state.confirmClose ? this.renderCloseDialog() : undefined}
            </Popover>
        );
    }

    handleClose = () => {
        if (this.state.isDirty) {
            this.setState({confirmClose: true});
        } else {
            this.props.onClose();
        }
    };

    handleSubmit = (data: UnserializedFilterObject<any>) => {
        this.props.onSubmit(data);
        this.props.onClose();
    };

    renderCloseDialog() {
        return (
            <Dialog
                anchor={this.closeButton}
                location='right'
                question='Discard changes?'
                onPrimary={this.props.onClose}
                onSecondary={() => this.setState({confirmClose: false})}
            />
        );
    }
}
